import styles from "./sponsors.module.scss";

/* GRID */
// export function Sponsors() {
//   return (
//     <div className={styles.sponsorsContainer}>
//       <section>
//         {sponsors.map((sponsor) => (
//           <SponsorButton key={sponsor.name} {...sponsor} />
//         ))}
//       </section>
//     </div>
//   );
// }
/* FLEX */
export function Sponsors() {
  return (
    <div className={styles.sponsorsContainerFlex}>
      <section>
        {sponsors.map((sponsor) => (
          <SponsorButton key={sponsor.name} {...sponsor} />
        ))}
      </section>
    </div>
  );
}

function SponsorButton({ sponsorName = "", logoSrc = "", websiteUrl = "" }) {
  return (
    <div
      // onClick={() => {
      //   if(!websiteUrl) return;
      //   window.open(websiteUrl, "_blank");
      // }}
      className={styles.sponsorImg}
    >
      {logoSrc && <img alt={sponsorName} src={logoSrc} />}
      {/* {sponsorName} */}
    </div>
  );
}

const sponsors = [
  // { sponsorName: "", logoSrc: "", websiteUrl: "" },
  {
    sponsorName: "Acera Benefits",
    logoSrc: "logos/acera-logo.png",
    websiteUrl: "",
  },
  {
    sponsorName: "Alaris Equity Partners",
    logoSrc: "logos/alaris-logo.png",
    websiteUrl: "",
  },
  {
    sponsorName: "Mic'd Up",
    logoSrc: "logos/micd-up-logo.png",
    websiteUrl: "",
  },
  {
    sponsorName: "Cold Garden",
    logoSrc: "logos/cold-garden-logo.png",
    websiteUrl: "",
  },
  {
    sponsorName: "EFW Radiology",
    logoSrc: "logos/efw-logo.png",
    websiteUrl: "",
  },
  {
    sponsorName: "Integrated Wealth Management",
    logoSrc: "logos/iwm-logo.png",
    websiteUrl: "",
  },
  {
    sponsorName: "Long View",
    logoSrc: "logos/longview-logo.png",
    websiteUrl: "",
  },
  {
    sponsorName: "Native Tongues",
    logoSrc: "logos/native-tongues-logo.png",
    websiteUrl: "",
  },
  {
    sponsorName: "OEB Breakfast",
    logoSrc: "logos/oeb-logo.png",
    websiteUrl: "",
  },
  {
    sponsorName: "Raven5",
    logoSrc: "logos/r5-logo.png",
    websiteUrl: "",
  },
  {
    sponsorName: "Student Housing Calgary",
    logoSrc: "logos/student-housing-calgary-logo.png",
    websiteUrl: "",
  },
  {
    sponsorName: "TD Insurance",
    logoSrc: "logos/td-insurance-logo.png",
    websiteUrl: "",
  },
  {
    sponsorName: "UNA Pizza & Wine",
    logoSrc: "logos/una-logo.png",
    websiteUrl: "",
  },
  {
    sponsorName: "William Huff Advertising",
    logoSrc: "logos/william-huff-logo.png",
    websiteUrl: "",
  },
  {
    sponsorName: "University of Calgary Alumni",
    logoSrc: "logos/uofc-alumni-logo.svg",
    websiteUrl: "",
  },
];
